(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["benefit-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const listenerFlag = 'benefitCardListenerBound';

    if (document.documentElement.dataset[listenerFlag] === 'true') return;

    document.documentElement.dataset[listenerFlag] = 'true';

    const syncCardState = (card, isOpen) => {
      const toggle = card.querySelector('[data-benefit-toggle]');

      if (!toggle) return;

      const title = card.querySelector('.benefit-card__title')?.textContent.trim() || 'benefit';

      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute('aria-label', `${isOpen ? 'Collapse' : 'Expand'} ${title}`);
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const toggle = event.target.closest('[data-benefit-toggle]');

      if (!toggle) return;

      const card = toggle.closest('[data-benefit-card]');

      if (!card) return;

      const shouldOpen = !card.classList.contains('active');
      const grid = card.closest('.grid-group, .benefits_living_grid');

      if (grid) {
        grid.querySelectorAll('[data-benefit-card].active').forEach((activeCard) => {
          if (activeCard === card) return;

          activeCard.classList.remove('active');
          syncCardState(activeCard, false);
        });
      }

      card.classList.toggle('active', shouldOpen);
      syncCardState(card, shouldOpen);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["scroll-highlight"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';
    const ACTIVATION_OFFSET = 200;
    if (customElements.get('lgd-scroll-highlight')) return;
    class ScrollHighlight extends HTMLElement {
      connectedCallback() {
        this.steps = Array.from(this.querySelectorAll('[data-scroll-highlight-step]'));
        if (!this.steps.length) return;
        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.frameId = null;
        window.addEventListener('scroll', this.handleViewportChange, { passive: true });
        window.addEventListener('resize', this.handleViewportChange, { passive: true });
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleViewportChange);
        window.removeEventListener('resize', this.handleViewportChange);
        if (this.frameId) {
          window.cancelAnimationFrame(this.frameId);
          this.frameId = null;
        }
      }
      handleViewportChange() {
        if (this.frameId) return;
        this.frameId = window.requestAnimationFrame(() => {
          this.update();
          this.frameId = null;
        });
      }
      update() {
        const activationLine = Math.max(0, window.innerHeight - ACTIVATION_OFFSET);
        this.steps.forEach((step) => {
          const rect = step.getBoundingClientRect();
          const passedActivationPoint = rect.bottom <= activationLine;
          const scrolledPast = rect.top <= 0;
          step.classList.toggle('is-active', passedActivationPoint || scrolledPast);
        });
      }
    }
    customElements.define('lgd-scroll-highlight', ScrollHighlight);
  })();
  } catch(e) { console.error(e); }
})();

})();
